/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ locale: NonNullable<unknown> }} Blog_Ai_Polish_In_LocaleInputs */

const cs_blog_ai_polish_in_locale = /** @type {(inputs: Blog_Ai_Polish_In_LocaleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vylepšit text (${i?.locale})`)
};

const en_blog_ai_polish_in_locale = /** @type {(inputs: Blog_Ai_Polish_In_LocaleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Polish ${i?.locale} copy`)
};

/**
* | output |
* | --- |
* | "Polish {locale} copy" |
*
* @param {Blog_Ai_Polish_In_LocaleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_ai_polish_in_locale = /** @type {((inputs: Blog_Ai_Polish_In_LocaleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Ai_Polish_In_LocaleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_ai_polish_in_locale(inputs)
	return cs_blog_ai_polish_in_locale(inputs)
});